import { IChatV2Schema } from '@cian/chats-api/lib/browser-entry';

import { EChatListActionTypes, IChatListRequest, TChatListSetSucceedPayload } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

/**
 * Установить начальное состояние чатов
 */
export const setChatListInitial = actionGenerator<EChatListActionTypes.SetInitial, void>(
  EChatListActionTypes.SetInitial,
);

/**
 * Запрос за списком чатов
 */
export const setChatListPending = actionGenerator<EChatListActionTypes.SetPending, IChatListRequest>(
  EChatListActionTypes.SetPending,
);

/**
 * Запрос за синхронизацией списка чатов
 */
export const setChatListSyncPending = actionGenerator<EChatListActionTypes.SetSyncPending, void>(
  EChatListActionTypes.SetSyncPending,
);

/**
 * Успешный ответ после синхронизации
 */
export const setChatListSyncSucceed = actionGenerator<EChatListActionTypes.SetSyncSucceed, TChatListSetSucceedPayload>(
  EChatListActionTypes.SetSyncSucceed,
);

/**
 * Установить ошибку синхронизации списка чатов
 */
export const setChatListSyncFailed = actionGenerator<EChatListActionTypes.SetSyncFailed, void>(
  EChatListActionTypes.SetSyncFailed,
);

/**
 * Успешное получение первой страницы списка
 */
export const setChatListLoadPageSucceed = actionGenerator<EChatListActionTypes.SetLoadPageSucceed, void>(
  EChatListActionTypes.SetLoadPageSucceed,
);

/**
 * Установить/убрать состояние загрузки списка чатов
 */
export const toggleChatListPending = actionGenerator<EChatListActionTypes.TogglePending, boolean>(
  EChatListActionTypes.TogglePending,
);

/**
 * Установить список чатов
 */
export const setChatListSucceed = actionGenerator<EChatListActionTypes.SetSucceed, TChatListSetSucceedPayload>(
  EChatListActionTypes.SetSucceed,
);

/**
 * Установить целый список чатов
 */
export const setFullChatListSucceed = actionGenerator<EChatListActionTypes.SetFullSucceed, TChatListSetSucceedPayload>(
  EChatListActionTypes.SetFullSucceed,
);

/**
 * Установить ошибку запроса списка чатов
 */
export const setChatListFailed = actionGenerator<EChatListActionTypes.SetFailed, void>(EChatListActionTypes.SetFailed);

/**
 * Обновление чата по веб-сокету
 */
export const updatedFromServer = actionGenerator<EChatListActionTypes.UpdatedFromServer, IChatV2Schema>(
  EChatListActionTypes.UpdatedFromServer,
);

/**
 * Установить состояние изменения списка
 */
export const toggleChangeListActive = actionGenerator<EChatListActionTypes.ToggleChangeListActive>(
  EChatListActionTypes.ToggleChangeListActive,
);

/**
 * Добавить чат в список выбранных чатов
 */
export const addChatToSelected = actionGenerator<EChatListActionTypes.AddChatToSelected, string>(
  EChatListActionTypes.AddChatToSelected,
);

/**
 * Удалить чат из списка выбранных чатов
 */
export const removeChatFromSelected = actionGenerator<EChatListActionTypes.RemoveChatFromSelected, string>(
  EChatListActionTypes.RemoveChatFromSelected,
);

/**
 * Добавить все чаты в список выбранных чатов
 */
export const selectAllChats = actionGenerator<EChatListActionTypes.SelectAllChats>(EChatListActionTypes.SelectAllChats);

/**
 * Удалить все чаты из списка выбранных чатов
 */
export const deselectAllChats = actionGenerator<EChatListActionTypes.DeselectAllChats>(
  EChatListActionTypes.DeselectAllChats,
);
